exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-a187f604!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/views/menu/MenuEdit.vue
// module id = 608
// module chunks = 2